var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottomNavLorryIconMobDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15h3v.5a1 1 0 01-1 1H4a1 1 0 01-1-1V15zM12 15h3v.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V15z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.751 9.75h10.5v-4a2 2 0 00-2-2h-6.5a2 2 0 00-2 2v4zm.875-1.5h8.749v-2a1 1 0 00-1-1h-6.75a1 1 0 00-1 1v2z",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75v-3zM15.75 6.75a.75.75 0 01-.75.75v-3a.75.75 0 01.75.75v1.5z",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.538 1.5a1.5 1.5 0 011.5 1.5H2.961a1.5 1.5 0 011.5-1.5h9.077zM2.25 10.25a2 2 0 012-2h9.499a2 2 0 012 2v3a1 1 0 01-1 1H3.25a1 1 0 01-1-1v-3zm4.5 1.25a1 1 0 011-1h2.499a1 1 0 011 1v2h-4.5v-2zm6.75-1.75a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM3 10.5a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75A.75.75 0 013 10.5zM14.999 15h-12v-.75h12V15z",
    fill: "#999"
  })));
}

export default SvgBottomNavLorryIconMobDisabled;